/**
 * The text of an answer's rounds as one. Each round is its own model call, so two rounds are two
 * paragraphs, never "…the Abbasid Caliphate.You could ask…": a round that ended by showing its answer
 * on the map is followed by the round after the tool, and both are the answer.
 *
 * Import-free so node:test runs it directly.
 */
export function joinRoundTexts(texts: readonly string[]): string {
  let joined = '';
  for (const text of texts) {
    if (!text) continue;
    if (joined && !/\s$/.test(joined) && !/^\s/.test(text)) joined += '\n\n';
    joined += text;
  }
  return joined;
}
